<title> Votaciones | ERROR</title>
<div class="d-flex">
  <div id="contenido" class="w-100">
    <div class="row justify-content-center align-items-center">
      <!-- Configuración del logo  -->
      <div class="col-lg-5">
        <div class="fondoLogo text-center">
          <div class="tituloEleccion">
            <p>Elecciones 2022</p>
          </div>
          <div class="card col-8 posicionCard"></div>
          <img class="logoCorhuilaBlanco" src="./assets/img/LogoCorhuilaBlanco.png">
        </div>
      </div>
      <div class="col-lg-7 seccion-iniciarSesion">
        <div class="margen-camposForm">
          <!-- Título -->
          <div class="marginCamposInicioSesion mb-4">
            {{page_title}}
            <div class="text-center mt-4"><br><br>
              <p class="fs-3"> <span class="text-danger">Opps!</span> Pagína no encontrada.</p>
              <p class="lead">
                La página que buscas no existe.
              </p><br>
              <button class="btn btn-primary btn-modal col-lg-2 col-sm-5" (click)="inicioSesion()">Iniciar
                Sesíon</button>
            </div>
          </div>
        </div>
        <!-- Footer -->
        <div class="position-sticky container" style="top: 100vh;">
          <footer>
            <div class="container text-center p-3">
              <blockquote class="blockquote"
                style="font-size: 15px; color: black; font-weight: 400; margin-bottom: 0%;">
                Copyright © 2022 · <a href="/desarrolladores" style="text-decoration: none; color: black"
                  target="_blank">Gestión TIC e Innovación Tecnológica</a> | <a href="https://www.corhuila.edu.co"
                  style="text-decoration: none; color: black;" target="_blank">Corporación Universitaria del Huila -
                  CORHUILA</a>
              </blockquote>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</div>
